import { lazy } from 'react';

export const IntakeForm = lazy(() => import(/*webpackChunkName: "intake-form" */ './intake-form/index'));
